// extracted by mini-css-extract-plugin
module.exports = {"container":"_1J0gAw6l4qI5eqFTbvmEsa","title":"T5VvXcyQ3OPSJlNRLOFCo appSubtitle"};